import React, { useEffect } from 'react'
import { keycloak } from '../lib'

export const AppMenuMountDiv = () => {
  const token = keycloak.token

  useEffect(() => {
    if (token) {
      // @ts-ignore
      window.tomraMenu.mount(token)
    }
  }, [token])

  return <div id="menu-root" data-testid="app-menu" />
}
